import { render, staticRenderFns } from "./base-column-country.vue?vue&type=template&id=0fd03c44&scoped=true&"
import script from "./base-column-country.vue?vue&type=script&lang=js&"
export * from "./base-column-country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd03c44",
  null
  
)

export default component.exports